import { cn } from '@finn/ui-utils';
import { ReactNode } from 'react';

type Props = {
  highlight?: boolean;
  children: ReactNode;
};

export const Label = ({ children, highlight }: Props) => {
  const highlightKeywords = [
    'Kategorie-Abo',
    'Reduziert',
    'DEAL5',
    'Spare',
    'sparst',
    'FINN30',
  ];
  const shouldHighlight =
    highlight ||
    highlightKeywords.some((keyword) =>
      (children as string)?.includes?.(keyword)
    );

  return (
    <p
      className={cn(
        'body-12-semibold',
        shouldHighlight ? 'text-trustedBlue' : 'text-iron'
      )}
    >
      {children}
    </p>
  );
};
